/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { TimeLineEntry } from 'components/timeLineEntry'
import { Mdx } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { ArticleTeasers, SortMode } from '@ta-interaktiv/react-article-teasers'
import {MetaInfos} from 'components/MetaInfos'
// TODO Set the correct article ID here
const ARTICLE_ID = '16220386'

const pointsOnTimeline = [
  { d: <>22. August 2006</>, t: '2006-August-22.mdx' },
  {
    d: (
      <>
        Rückblick
        <br />
        1994 – 1999
      </>
    ),
    t: '1994-1999.mdx',
    s: 'back'
  },
  { d: '2010-2015', t: '2010-2015.mdx' },
  {
    d: (
      <>
        16. September
        <br />
        2016
      </>
    ),
    t: '2016-september-16.mdx'
  },
  {
    d: (
      <>
        Oktober bis Dezember
        <br />
        2016
      </>
    ),
    t: '2016-oktober-dezember.mdx'
  },
  {
    d: (
      <>
        Rückblick
        <br />
        1973 – 1993
      </>
    ),
    t: '1973-1993.mdx',
    s: 'back'
  },
  {
    d: (
      <>
        Februar bis März
        <br /> 2017
      </>
    ),
    t: '2017-februar-maerz.mdx'
  },
  {
    d: (
      <>
        April bis September
        <br />
        2017
      </>
    ),
    t: '2017-april-september.mdx'
  },
  {
    d: (
      <>
        September bis Dezember
        <br />
        2017
      </>
    ),
    t: '2017-september-dezember.mdx'
  },
  {
    d: (
      <>
        Januar bis März
        <br />
        2018
      </>
    ),
    t: '2018-januar-maerz.mdx'
  },
  {
    d: (
      <>
        April bis Juni
        <br />
        2018
      </>
    ),
    t: '2018-april-juni.mdx'
  },
  { d: 'Juli 2018', t: '2018-juli.mdx' },
  {
    d: (
      <>
        August bis September
        <br />
        2018
      </>
    ),
    t: '2018-august-september.mdx'
  },
  { d: 'Oktober 2018', t: '2018-oktober.mdx' },
  {
    d: (
      <>
        22. bis 23. Oktober
        <br />
        2018
      </>
    ),
    t: '2018-oktober-22-23.mdx'
  },
  { d: 'November 2018  ', t: '2018-november.mdx' },
  { d: 'Dezember 2018  ', t: '2018-dezember.mdx' },
  {
    d: (
      <>
        September bis Dezember
        <br />
        2019
      </>
    ),
    t: '2019-september.mdx'
  },
  { d: 'Januar 2020', t: '2020-januar-2.mdx' }
]
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />
      {/* TODO Replace the following segment with your project cover */}
      <header className='ui vertical very relaxed  segment'>
        <div className='ui container'>
          <h1 className='ui image header'>
            <div className='content'>
              Justiz liess Pädophilen gewähren
              <div className='sub header'>
                Eigentlich mussten die Solothurner Behörden William W. streng
                überwachen. Doch der vorbestrafte Kinderschänder war immer
                wieder ohne Fussfessel unterwegs. Nichts passierte. Und so soll
                sich der 46-Jährige an fünf weiteren Minderjährigen vergangen
                haben. Heute findet der Prozess am Amtsgericht Olten-Gösgen
                statt.
              </div>
            </div>
          </h1>
        </div>
      </header>
      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <MetaInfos authors={['Roland Gamp']} updated={"Aktualisiert am 3. Dezember 2020"}/>
          <Mdx file={require('text/2020-januar.mdx')} className='cbMDX intro' />
        </div>
      </div>
      <div className='ui vertical very fitted segment'>
        <div className='ui container main'>
          <div className='ui stackable grid'>
            {!browserCheck.isMobile && (
              <div className='row'>
                <div className='two wide column' />
                <div className='two wide column start'>
                  <div className='line' />
                  <div className='timelineStart' />
                </div>
                <div className='ten wide column' />
              </div>
            )}

            {/* <div className='timeLineStart' /> */}
            {pointsOnTimeline.map((p, i) => {
              let cl = ''
              if (i % 2 === 0) cl = 'second'
              if (i === 0) cl += ' first'
              if (p.s) cl += p.s ? p.s : ''
              return <TimeLineEntry date={p.d} textFile={p.t} className={cl} />
            })}
            {!browserCheck.isMobile && (
              <div className='row end'>
                <div className='two wide column' />
                <div className='two wide column '>
                  <div className='line' />
                </div>
                <div className='ten wide column' />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <Mdx file={require('text/future.mdx')} />
        </div>
      </div>
      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <ArticleTeasers
            sorting={SortMode.REVERSE_CHRONOLOGICALLY_BY_CREATION_DATE}
            articleIds={['16188351']}
          />
        </div>
      </div>
      {/* TODO Add your credits in this component */}
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          ['Text', 'Roland Gamp'],
          ['Umsetzung', 'Sebastian Broschinski']
        ]}
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        inverted
        hidePortfolioTeaser
      />
    </div>
  )
}
